const messages = {
  es: {
    translations: {

      common: {
        deleteRecord: "Eliminar registro",
        close: "Cerrar",
        back: "Volver",
        total: "Total",
        client: "Cliente",
        required: "Obligatorio",
        messageTooShort: "Mensaje demasiado corto"
      },
      ToDoList: "Lista de tareas",
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!.",
          fail: "Error al crear el usuario. Comprueba los datos introducidos."
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "Whatsapp (Código de área + NÚMERO)"
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!"
        }
      },
      login: {
        title: "Iniciar Sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          button: "Acceder"
        },
        buttons: {
          submit: "Iniciar Sesión",
          register: "¿No tienes una cuenta? ¡Regístrate!"
        }
      },
      loading: {
        loadingSystem: "Cargando el sistema",
        pleaseWait: "Por favor espera...",
        preparing: "Preparando entorno...",
        connecting: "Conectando con el servidor...",
        syncing: "Sincronizando datos...",
        label: "Cargando..."
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!"
        }
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!"
        },
        dueDate: {
          expiration: "Tu suscripción vence en",
          days: "¡días!",
          day: "¡día!",
          expirationToday: "¡Tu suscripción vence hoy!"
        },
        token: "Token"
      },
      dashboard: {
        title: "Panel de Control",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
          performance: "Rendimiento"
        },
        charts: {
          performance: "Gráficos",
          userPerformance: "Gráfico de Usuarios",
          perDay: {
            title: "Atendimientos hoy: "
          }
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "En Espera",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "T.M. de Atención",
          averageWaitingTime: "T.M. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos"
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atendimientos",
          statusNow: "Actual",
          totalCallsUser: "Total de atendimientos por usuario",
          totalAttendances: "Total de atendimientos",
          queues: "Colas",
          defaultQueue: "Conexión Predeterminada",
          workingHours: "Horario Laboral",
          startWork: "Inicio de Trabajo",
          endWork: "Fin de Trabajo",
          farewellMessage: "Mensaje de Despedida",
          theme: "Tema Predeterminado",
          menu: "Menú Predeterminado",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final"
        },
        licence: {
          available: "Disponible hasta"
        },
        assessments: {
          totalCalls: "Total de Atendimientos",
          callsWaitRating: "Atendimientos esperando evaluación",
          callsWithoutRating: "Atendimientos sin evaluación",
          ratedCalls: "Atendimientos evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detractores"
        },
        buttons: {
          filter: "Filtrar"
        },
        toasts: {
          configureFilter: "Configura el filtro de fechas"
        },
        emptyState: {
          noChartData: "No hay datos disponibles para el período seleccionado"
        }
      },
      reports: {
        title: "Informe de Encuestas Realizadas",
        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atendimientos",
        search: "Encuestas",
        durationCalls: "Duración de los Atendimientos",
        grupoSessions: "Atendimientos en Grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generando informe comprimido, por favor espere.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Informe de Atendimientos en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha de Última Actualización",
          agent: "Quién Atendió",
          agentClosed: "Quién Cerró",
          waitingAssistance: "Esperando Atención",
          process: "En Atención"
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Informe de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva"
        },
        ticketDurationDetail: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Duración del Atendimiento",
          startService: "Inicio del Atendimiento",
          lastUpdated: "Última Actualización",
          lastAgent: "Último Agente",
          durationFinished: "Duración después de finalizado"
        },
        ticketDuration: {
          title: "Informe de Duración de los Atendimientos",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones"
        },
        ticketReports: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Atendimientos"
        },
        pdf: {
          title: "Relación de Atendimientos Realizados",
          exportTitle: "Relación de Atendimientos en Grupos Realizados"
        }
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas"
      },
      contactImportWpModal: {
        title: "Exportar Contactos para el Excel",
        exportImportTitle: "Exportar / Importar contactos",
        buttons: {
          downloadModel: "Descargar modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar Contactos"
        }
      },
      contactList: {
        success: "Lista de contactos guardada con éxito."
      },
      connections: {
        title: "Conectores",
        subtitle: "Gestiona canales, integraciones y conectores del sistema",
        waitConnection: "Espera... ¡Tus conectores se reiniciarán!",
        newConnection: "Nuevo conector",
        addChannel: "Agregar conector",
        integrationsSection: {
          title: "Integraciones e IA",
          subtitle: "Configura Open AI, automatizaciones y conectores para tus flujos y colas",
          planDisabled: "Tu plan no incluye esta integración."
        },
        addChannelModal: {
          title: "Conectores disponibles",
          subtitleGallery: "Elige un conector para vincular con tu CRM",
          subtitleConfig: "Configura la conexión con las opciones predeterminadas",
          comingSoon: "Próximamente",
          comingSoonTitle: "Integración en desarrollo",
          comingSoonDesc: "Este canal estará disponible en una próxima actualización.",
          sectionMessaging: "Mensajería",
          sections: {
            all: "Canales e integraciones",
            channels: "Canales",
            messaging: "Mensajería",
            social: "Redes sociales",
            email: "Correo",
            integrations: "Integraciones e IA"
          },
          stepsTitle: "ETAPAS DE CONEXIÓN",
          filters: {
            all: "Todo",
            messaging: "Mensajería",
            social: "Redes sociales",
            email: "Correo",
            integrations: "Integraciones"
          },
          channels: {
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            instagram: "Instagram",
            tiktok: "TikTok",
            zoho: "Zoho Mail"
          },
          integrations: {
            openai: "Open AI",
            openaiDesc: "Crea configuraciones independientes (chat interno, colas, flujos…)",
            tavily: "Búsqueda web (Tavily)",
            tavilyDesc: "Conecta Tavily y elige qué configuraciones Open AI pueden buscar en internet",
            chatAgent: "Agente IA de chats",
            chatAgentDesc: "Asigna qué configuraciones Open AI analizan conversaciones (solo asesor interno)",
            dialogflow: "Dialogflow",
            n8n: "N8N",
            webhook: "Webhook",
            typebot: "Typebot",
            flowbuilder: "Flow Builder"
          },
          whatsapp: {
            provider: "Conexión estándar",
            description: "Crea la conexión, escanea el código QR y empieza a atender desde el CRM.",
            name: "Nombre de la conexión",
            step1: "Datos configurados",
            step2: "Escanear código QR",
            step3: "Conexión activa",
            advanced: "Configuración avanzada",
            continue: "Crear y conectar"
          },
          facebook: {
            description: "Conecta tu página de Facebook para recibir y responder mensajes desde el CRM.",
            connect: "Conectar vía Facebook OAuth"
          },
          instagram: {
            description: "Conecta tu cuenta de Instagram Business para gestionar mensajes directos.",
            connect: "Conectar vía Instagram OAuth"
          },
          meta: {
            step1: "Canal seleccionado",
            step2: "Clic en conectar",
            step3: "Autorizar en la ventana",
            oauthNote: "Se abrirá una ventana para autenticación. Al finalizar, el canal se creará automáticamente."
          }
        },
        zohoModal: {
          title: "Conectar Zoho Mail",
          name: "Nombre de la conexión",
          email: "Correo electrónico",
          authUser: "Usuario IMAP/SMTP (opcional)",
          authUserHint: "Si está vacío, se usa el correo electrónico",
          appPassword: "Contraseña de aplicación",
          appPasswordHint: "Genera una contraseña de aplicación en la configuración de Zoho Mail",
          region: "Región de Zoho",
          test: "Probar conexión",
          connect: "Conectar",
          testSuccess: "Conexión IMAP/SMTP verificada correctamente",
          success: "Zoho Mail conectado correctamente",
          editTitle: "Editar Zoho Mail",
          save: "Guardar",
          updateSuccess: "Conexión Zoho Mail actualizada",
          emailLocked: "El correo no se puede cambiar en una conexión existente",
          appPasswordEditHint: "Deja vacío para mantener la contraseña actual",
          passwordRequiredForTest: "Ingresa la contraseña de aplicación para probar",
          smtpPort: "Puerto SMTP"
        },
        restartConnections: "Reiniciar WhatsApp",
        callSupport: "Llamar Soporte",
        empty: "No hay conectores configurados",
        filters: {
          default: "Predeterminado",
          name: "A-Z",
          type: "Por tipo",
          status: "Por estado"
        },
        categoryFilters: {
          all: "Todos",
          channels: "Canales",
          integrations: "Integraciones",
          openai: "Open AI"
        },
        openAiSection: {
          title: "Open AI",
          subtitle: "Cada configuración es independiente: distinto prompt, modelo y API key",
          add: "Agregar Open AI",
          empty: "Aún no tienes configuraciones Open AI",
          count: "{{count}} configuración(es)"
        },
        status: {
          CONNECTED: "Conectado",
          DISCONNECTED: "Desconectado",
          OPENING: "Conectando",
          qrcode: "Esperando QR",
          PAIRING: "Emparejando",
          TIMEOUT: "Tiempo agotado"
        },
        card: {
          updated: "Actualizado",
          default: "Predeterminado",
          checkSettings: "Revisa la configuración del canal",
          edit: "Editar",
          delete: "Eliminar"
        },
        integrationCard: {
          active: "ACTIVO",
          configured: "Integración configurada y lista para usar",
          openAiConfigured: "Configuración Open AI independiente",
          tavilyConfigured: "Búsqueda web Tavily conectada",
          tavilyPrompts: "{{count}} Open AI con búsqueda web",
          chatAgentConfigured: "Agente IA de chats conectado",
          chatAgentPrompts: "{{count}} Open AI para análisis de chats",
          webSearch: "Búsqueda web",
          edit: "Configurar"
        },
        toasts: {
          deleted: "¡Conexión eliminada con éxito!",
          closedimported: "Estamos cerrando los tickets importados, por favor espere unos instantes"
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage: "Si confirmas, todos los tickets importados serán cerrados",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          deleteIntegrationTitle: "Eliminar integración",
          deleteIntegrationMessage: "¿Estás seguro? Esta integración dejará de estar disponible en tus colas.",
          deletePromptTitle: "Eliminar Open AI",
          deletePromptMessage: "¿Estás seguro? Este prompt dejará de estar disponible.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Deberás leer el código QR de nuevo."
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          syncEmail: "Sincronizar",
          closedImported: "Cerrar todos los tickets importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes de WhatsApp",
          newQr: "Nuevo CÓDIGO QR",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando"
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje"
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrate de que tu celular esté conectado a internet y intenta de nuevo, o solicita un nuevo Código QR"
          },
          qrcode: {
            title: "Esperando lectura del Código QR",
            content: "Haz clic en el botón 'CÓDIGO QR' y lee el Código QR con tu celular para iniciar la sesión"
          },
          connected: {
            title: "¡Conexión establecida!"
          },
          timeout: {
            title: "La conexión con el celular fue perdida",
            content: "Asegúrate de que tu celular esté conectado a internet y el WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo Código QR"
          }
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          "default": "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp"
        },
        facebook: {
          success: "Conexión de Facebook/Instagram establecida con éxito."
        },
        plan: {
          whatsappDisabled: "Tu plan no incluye WhatsApp."
        }
      },
      allConnections: {
        table: {
          client: "Cliente",
          connected: "Conexiones conectadas",
          disconnected: "Conexiones desconectadas",
          totalConnections: "Total de conexiones"
        }
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimiento Existente"
        },
        form: {
          message: "Este contacto ya está en atendimiento:",
          user: "Agente",
          queue: "Cola",
          messageWait: "Este contacto ya está esperando atendimiento. ¡Ve en la pestaña Esperando!"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Registros"
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Cola definida.",
          open: " inició el atendimiento.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió la cola.",
          closed: "cerró el ticket",
          reopen: "reabrió el ticket",
          redirect: "- redirigido"
        }
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexión",
          edit: "Editar Conexión"
        },
        subtitle: {
          add: "Configura tu nueva conexión de WhatsApp",
          edit: "Ajusta los parámetros de la conexión"
        },
        sections: {
          media: "Medios de bienvenida",
          mediaDesc: "Imagen o video opcional para el mensaje de bienvenida.",
          import: "Importación de mensajes",
          tokenDesc: "Úsalo para integraciones externas con esta conexión."
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          chatbot: "Chatbot",
          flowbuilder: "Flujo predeterminado",
          schedules: "Horario de atención"
        },
        flows: {
          welcomeTitle: "Flujo de bienvenida",
          welcomeDesc: "Este flujo se dispara solo para contactos nuevos que no están en tu lista y te escriben por primera vez.",
          defaultTitle: "Flujo de respuesta predeterminada",
          defaultDesc: "Se envía cuando el mensaje no coincide con una palabra clave. Atención: se dispara aunque el ticket esté cerrado."
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessages: "Fecha de inicio de la importación",
          importRecentMessages: "Fecha de finalización de la importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Cola",
          queueRedirectionDesc: "Selecciona una cola para que los contactos que no tienen cola sean redirigidos",
          "default": "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert: "ATENCIÓN: Al guardar, tu conexión se cerrará, será necesario leer de nuevo el Código QR para importar los mensajes",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear nuevo ticket en x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          expiresTicket: "Cerrar chats abiertos después de x minutos",
          expiresTicketNPS: "Cerrar chats esperando evaluación después de x minutos",
          maxUseBotQueuesNPS: "Cantidad máxima de veces que la evaluación va a ser enviada",
          closeLastMessageOptions1: "Del agente/Cliente",
          closeLastMessageOptions2: "Del agente",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para política de privacidad",
          lgpdMessage: "Mensaje de bienvenida LGPD",
          lgpdDeletedMessages: "Ocultar mensaje borrado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - La escala debe ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Tiempo en minutos para envío del aviso de inactividad",
          whenExpiresTicket: "Cerrar chats abiertos cuando la última mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importar los mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          refreshToken: "Generar nuevo token",
          copyToken: "Copiar token"
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos"
        },
        success: "Conexión guardada con éxito.",
        errorSendQueue: "Se informó tiempo para redirigir cola, pero no se seleccionó fila para redirigir. Ambos campos deben estar llenos",
        errorExpiresNPS: "Es obligatorio informar un tiempo para evaluación cuando se utiliza el NPS.",
        errorRatingMessage: "Es obligatorio informar un mensaje de evaluación cuando se utiliza el NPS."
      },
      qrCode: {
        title: "Conectar WhatsApp",
        subtitle: "Escanea el código con tu teléfono para vincular la sesión",
        message: "Lee el QrCode para iniciar la sesión",
        waiting: "Generando código QR...",
        hint: "Abre WhatsApp → Dispositivos vinculados → Vincular dispositivo"
      },
      contacts: {
        title: "Contactos",
        facebookFallbackName: "Usuario Facebook",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          blocked: "Contacto bloqueado",
          unblocked: "Contacto desbloqueado",
          deletedSelected: "Contactos seleccionados eliminados con éxito"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage: "¿Estás seguro de que deseas eliminar este contacto? Todos los atendimientos relacionados se perderán.",
          blockContact: "¿Estás seguro de que deseas bloquear este contacto?",
          unblockContact: "¿Estás seguro de que deseas desbloquear este contacto?",
          blockTitle: "¿Bloquear contacto",
          unblockTitle: "¿Desbloquear contacto",
          chooseConnectionImport: "Elige desde qué conexión deseas importar",
          deleteManyTitle: "¿Estás seguro de que deseas eliminar los contactos seleccionados?",
          deleteManyMessage: "Esta acción es irreversible.",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport: "¿Desea importar todas las conversaciones del teléfono?"
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
          deleteSelected: "Eliminar seleccionados"
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          email: "Correo electrónico",
          actions: "Acciones",
          lastMessage: "Último mensaje",
          status: "Estado"
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar del Excel"
        },
        filters: {
          createdAt: "Fecha de creación",
          to: "Hasta"
        }
      },
      forwardMessage: {
        text: "Reenviada"
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar"
        }
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Región de Voz",
          model: "Modelo",
          purpose: "Propósito"
        },
        purpose: {
          queue: "Cola / WhatsApp",
          internalAssistant: "Asistente flotante interno",
          chatAgent: "Análisis de conversaciones"
        },
        success: "¡Prompt guardado con éxito!",
        title: {
          add: "Nueva configuración Open AI",
          edit: "Editar configuración Open AI"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        }
      },
      webSearchIntegrationModal: {
        title: {
          add: "Conectar búsqueda web (Tavily)",
          edit: "Editar búsqueda web (Tavily)"
        },
        form: {
          name: "Nombre del conector",
          apiKey: "API Key de Tavily",
          apiKeyHint: "Obtén tu clave en tavily.com",
          apiKeyEditHint: "Deja vacío para mantener la clave actual",
          apiKeyRequired: "Informa la API Key de Tavily",
          promptsTitle: "Open AI con búsqueda web",
          promptsHint: "Selecciona una o más configuraciones Open AI que podrán consultar internet en tiempo real",
          noPrompts: "No hay configuraciones Open AI. Agrégalas con «Agregar conector» → Open AI en esta página."
        },
        buttons: {
          add: "Conectar",
          save: "Guardar",
          cancel: "Cancelar"
        },
        success: {
          add: "Búsqueda web conectada con éxito",
          edit: "Búsqueda web actualizada con éxito"
        }
      },
      chatAgentIntegrationModal: {
        title: {
          add: "Conectar Agente IA de chats",
          edit: "Editar Agente IA de chats"
        },
        form: {
          name: "Nombre del conector",
          promptsTitle: "Open AI para análisis",
          promptsHint: "Selecciona una o más configuraciones Open AI que analizarán conversaciones (no responden al cliente)",
          promptsRequired: "Selecciona al menos una configuración Open AI",
          noPrompts: "No hay configuraciones Open AI. Agrégalas con «Agregar conector» → Open AI en esta página.",
          defaultHint: "Marca con el círculo cuál es la configuración por defecto"
        },
        buttons: {
          add: "Conectar",
          save: "Guardar",
          cancel: "Cancelar"
        },
        success: {
          add: "Agente IA de chats conectado con éxito",
          edit: "Agente IA de chats actualizado con éxito"
        }
      },
      ticketAiAnalysis: {
        title: "Análisis IA",
        analyze: "Analizar con IA",
        analyzing: "Analizando conversación…",
        empty: "Pulsa «Analizar con IA» para obtener un resumen, intención y respuesta sugerida.",
        notConfigured: "No hay configuraciones Open AI disponibles.",
        notConfiguredSteps: "Crea al menos una configuración Open AI en Conectores para poder analizar conversaciones.",
        settings: "Configuración",
        settingsTitle: "Agente IA asignado",
        settingsHint: "Elige qué configuración Open AI usará el análisis de esta conversación.",
        activeAgent: "Activo: {{name}}",
        openSettingsHint: "Abre Configuración para elegir el agente IA de esta conversación.",
        refreshConfig: "Actualizar lista de agentes",
        configRefreshed: "Lista de agentes actualizada",
        configRefreshFailed: "No se pudo cargar la configuración del agente",
        prompt: "Agente / Open AI",
        historyScopeLabel: "Historial a analizar",
        historyScopeHint: "En chats largos se usan los mensajes de texto más recientes del periodo elegido.",
        willAnalyze: "Se analizará: {{scope}}",
        analysisMeta: "{{count}} mensajes · {{scope}}",
        historyScope: {
          all: "Todo el historial (máx. 200 mensajes)",
          week: "Última semana",
          month: "Último mes",
          last_50: "Últimos 50 mensajes",
          last_100: "Últimos 100 mensajes",
          last_200: "Últimos 200 mensajes",
        },
        history: "Historial",
        refineTitle: "Ajustar con contexto",
        refineHint: "Indica algo que la IA no ve en el chat (ej. hace días sin contacto, cotización enviada por correo).",
        refinePlaceholder: "Ej: No le hablo hace 3 días, necesito reabrir sin ser invasivo…",
        refine: "Refinar sugerencia",
        refining: "Refinando…",
        refineSuccess: "Sugerencia actualizada con tu contexto",
        refinedBadge: "Refinado",
        refineContext: "Contexto: {{text}}",
        copied: "Respuesta copiada al portapapeles",
        fields: {
          resumen: "Resumen",
          necesidadPrincipal: "Necesidad principal",
          proximoPaso: "Próximo paso",
          respuestaSugerida: "Respuesta sugerida (revisar antes de enviar)"
        }
      },
      flowOpenAiModal: {
        title: {
          add: "Agregar OpenAI/Gemini al flujo",
          edit: "Editar OpenAI/Gemini del flujo"
        },
        buttons: {
          add: "Agregar",
          save: "Guardar"
        },
        tabs: {
          general: "General",
          prompt: "Instrucciones",
          handoff: "Pase a humano"
        },
        sections: {
          hint: "Divide la inteligencia del asistente en secciones. El sistema las combina automáticamente para que la IA no pierda contexto.",
          role: "Rol y objetivo",
          roleHint: "Quién es el asistente y cuál es su misión principal.",
          rules: "Reglas de conducta",
          rulesHint: "Tono, límites, qué debe y no debe hacer.",
          knowledge: "Información del negocio",
          knowledgeHint: "Productos, precios, horarios, políticas, FAQs, etc.",
          restrictions: "Restricciones",
          restrictionsHint: "Temas prohibidos, límites de soporte, escalaciones.",
          examples: "Ejemplos",
          examplesHint: "Ejemplos de respuestas ideales para guiar a la IA."
        },
        handoff: {
          hint: "Cuando el cliente quiera hablar con una persona, el flujo saldrá del asistente y continuará por el conector de salida del nodo (Ticket, mensaje, etc.).",
          enabled: "Activar pase a atención humana",
          keywords: "Palabras clave del cliente",
          keywordsHint: "Separadas por coma. Si el mensaje del cliente contiene alguna, se activa el pase.",
          aiTrigger: "Frase de la IA para transferir",
          aiTriggerHint: "Si la IA detecta intención humana, debe responder con esta frase exacta.",
          message: "Mensaje automático al transferir",
          messageHint: "Texto que verá el cliente al pasar a un agente humano.",
          mode: "Modo de transferencia",
          modeFlow: "Seguir conector del flujo (recomendado)",
          modeQueue: "Enviar directo a una cola",
          queue: "Cola de destino",
          noQueue: "Ninguna",
          flowTipTitle: "Conector de salida",
          flowTip: "Conecta la salida derecha de este nodo OpenAI a un nodo Ticket o Contenido. Al activarse el pase, el flujo continuará por ese cable."
        },
        validation: {
          nameMin: "Nombre demasiado corto",
          nameMax: "Nombre demasiado largo",
          model: "Modelo inválido",
          modelRequired: "Selecciona un modelo",
          tokensMin: "Mínimo 10 tokens",
          tokensMax: "Máximo 4096 tokens",
          tempMin: "Mínimo 0",
          tempMax: "Máximo 1",
          apiKey: "Informa la API Key",
          messagesMin: "Mínimo 1 mensaje",
          messagesMax: "Máximo 50 mensajes",
          promptMin: "Completa al menos una sección de instrucciones (mínimo 20 caracteres)."
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!"
        },
        buttons: {
          add: "Agregar Prompt"
        }
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto"
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo electrónico",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          chatBotContact: "Deshabilitar chatbot",
          termsLGDP: "Términos LGPD aceptados en:",
          whatsapp: "Conexión Origen: ",
          attendant: "Agente",
          queue: "Cola",
          customer_portfolio: "Cartera de clientes"
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Contacto guardado con éxito.",
        contactMergedOnSave: "Lead asociado al contacto existente en tu agenda."
        },
       flowbuilder: {
        title: "Flowbuilder",
        subMenus: {
          campaign: "Flujo de Campaña",
          conversation: "Flujo de Conversación"
        },
        drawFlow: "Dibuja tu flujo",
        conversationFlows: "Flujos de conversación",
        addFlow: "Agregar Flujo",
        editName: "Editar nombre",
        editFlow: "Editar flujo",
        duplicate: "Duplicar",
        delete: "Eliminar",
        content: "Contenido",
        randomizer: "Aleatorizador",
        flowStart: "Inicio del flujo",
        flowStartDescription: "Este bloque marca el inicio de tu flujo!",
        active: "Activo",
        inactive: "Inactivo",
        deleteFlowMessage: "¿Estás seguro de que deseas eliminar este flujo? Todas las integraciones relacionadas se perderán.",
        duplicateFlowTitle: "¿Deseas duplicar el flujo {name}?",
        chooseFlow: "Elige un flujo",
        duplicateFlowMessage: "¿Estás seguro de que deseas duplicar este flujo?",
        flowDeleted: "Flujo eliminado con éxito",
        flowDuplicated: "Flujo duplicado con éxito",
        defaultFlow: "Flujo predeterminado",
        welcomeFlow: "Flujo de bienvenida",
        welcomeFlowDesc: "Este flujo se activa solo para contactos nuevos, personas que no tienes en tu lista de contactos y que enviaron un mensaje.",
        defaultReplyFlow: "Flujo de respuesta predeterminada",
        defaultReplyFlowDesc: "La respuesta predeterminada se envía con cualquier carácter que no sea una palabra clave. ATENCIÓN: se activará si el ticket ya está cerrado y han pasado 6 horas desde su cierre.",
        menu: "Menú",
        interval: "Intervalo",
        question: "Pregunta",
        ticket: "Ticket",
        start: "Inicio",
        import: "Importar",
        export: "Exportar",
        save: "Guardar",
        saveReminder: "¡No olvides guardar tu flujo!",
        intervalSec: "Intervalo {sec} seg.",
        text: "Texto",
        image: "Imagen",
        audio: "Audio",
        video: "Video",
        audioSent: "Audio enviado",
        recordedLive: "Grabado en el momento",
        sendAsRecordedLive: "Enviar como audio grabado en el momento",
        seconds: "{sec} segundos",
        browserNoHtml5: "tu navegador no admite HTML5",
        variables: "Variables"
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flujo predeterminado",
        menuExplanation: "Mensaje de explicación del menú",
        addOption: "Agregar Opción",
        option: "Opción",
        writeOption: "Escriba la opción",
        addMenuToFlow: "Agregar menú al flujo",
        editMenu: "Editar menú",
        buttons: {
          add: "Agregar",
          edit: "Editar",
          save: "Guardar",
          cancel: "Cancelar",
          import: "Importar",
          chooseFile: "Elegir archivo"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          enterName: "¡Ingresa un nombre!",
          enterMessage: "¡Ingresa un mensaje!",
          addIntervalValue: "Agrega el valor del intervalo",
          addQueue: "Agrega una cola"
        },
        text: {
          addTitle: "Agregar mensaje al flujo",
          editTitle: "Editar mensaje del flujo"
        },
        content: {
          addTitle: "Agregar contenido al flujo",
          editTitle: "Editar contenido",
          uploadProgress: "Subiendo archivos y creando el contenido...",
          emptyCardsError: "Elimine las tarjetas vacías (Imagen, Audio y Video)",
          intervalError: "El intervalo no puede ser 0 ni mayor que 120",
          emptyMessageFields: "¡Campos de mensaje vacíos!"
        },
        question: {
          addTitle: "Agregar pregunta al flujo",
          editTitle: "Editar pregunta del flujo",
          createTitle: "Crear pregunta en el flujo",
          editShort: "Editar pregunta",
          saveAnswer: "Guardar respuesta"
        },
        audio: {
          addTitle: "Agregar audio al flujo",
          editTitle: "Editar audio",
          added: "¡Audio agregado con éxito!",
          updated: "¡Audio modificado con éxito!"
        },
        image: {
          addTitle: "Agregar imagen al flujo",
          editTitle: "Editar imagen"
        },
        video: {
          addTitle: "Agregar video al flujo",
          editTitle: "Editar video",
          added: "¡Video agregado con éxito!",
          updated: "¡Video modificado con éxito!"
        },
        interval: {
          addTitle: "Agregar un intervalo al flujo",
          editTitle: "Editar intervalo",
          timeInSeconds: "Tiempo en segundos",
          maxTimeError: "Tiempo máximo alcanzado: 120 segundos"
        },
        randomizer: {
          addTitle: "Agregar un aleatorizador al flujo",
          editTitle: "Editar aleatorizador",
          addPercentValue: "Agrega el valor del porcentaje"
        },
        condition: {
          addTitle: "Agregar condición al flujo",
          editTitle: "Editar condición",
          fieldLabel: "Campo de la condición (ingresa solo 1 clave)",
          valueLabel: "Valor de la condición a analizar",
          validationRule: "Regla de validación"
        },
        ticket: {
          addTitle: "Agregar una cola al flujo",
          editTitle: "Editar cola"
        },
        typebot: {
          addTitle: "Agregar Typebot al flujo",
          editTitle: "Editar Typebot",
          editFlowTitle: "Editar Typebot del flujo"
        },
        import: {
          title: "Importar flujo",
          description: "Selecciona un archivo .zip exportado por el Flowbuilder.",
          noFile: "Ningún archivo seleccionado",
          selectZip: "Selecciona un archivo .zip",
          success: "¡Flujo importado con éxito!",
          error: "Error al importar el flujo."
        }
      },
      queueModal: {
        title: {
          queueData: "Datos de la cola",
          text: "Horarios de atención",
          add: "Agregar cola",
          edit: "Editar cola",
          confirmationDelete: "¿Estás seguro? Todas las opciones de integraciones serán eliminadas."
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la cola (Bot)",
          rotate: "Rotación",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menú",
          message: "Mensaje de retorno",
          queue: "Cola para transferencia",
          integration: "Integración",
          file: "Archivo"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue opciones para construir un chatbot",
          toolTip: "Si hay solo una opción, se elegirá automáticamente, haciendo que el bot responda con el mensaje de la opción y siga adelante",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Cola",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipMessageContent: "El mensaje es obligatorio para seguir al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Cola",
          selectIntegration: "Seleccione una Integración",
          addOptions: "Agregar opciones"
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo"
        }
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto"
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "Contenido Json",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot"
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito."
        }
      },
      userModal: {
        warning: {
          import: "¡Para hacer la importación de los mensajes es necesario leer el qrCode nuevamente !!!",
          updateImage: "Actualizar imagen"
        },
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar imagen",
          removeImage: "Eliminar imagen"
        },
        form: {
          name: "Nombre",
          none: "Ninguna",
          email: "Correo electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          whatsapp: "Conexión Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Visualizar llamadas sin cola",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de otras colas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atendimientos",
          allowConnections: "Permitir conexiones",
          allowConnectionFacebook: "Facebook",
          allowConnectionInstagram: "Instagram",
          allowConnectionWhatsapp: "WhatsApp",
          allowConnectionEmail: "Zoho Mail",
          allowKanban: "Acceso al Kanban",
          allowSchedules: "Mensajes programados"
        },
        tabs: {
          general: "General",
          permissions: "Permisos"
        },
        permissions: {
          hint: "Activa las opciones que este usuario puede usar. En «Permitir conexiones» elige qué canales puede ver y conectar."
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen"
        },
        success: "Usuario guardado con éxito."
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          passwordOptional: "Déjalo vacío para no cambiar la contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
          plan: "Plan"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Empresa guardada con éxito."
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación"
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          connection: "Conexión",
          selectConnectionFirst: "Selecciona primero la conexión para ver los contactos de Facebook o Instagram",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma"
        },
        validation: {
          bodyMin: "Mensaje demasiado corto",
          required: "Obligatorio"
        },
        titleStatus: {
          sendError: "Error de envío",
          message: "Mensaje"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programación",
          delete: "Eliminar"
        },
        success: "Programación guardada con éxito.",
        confirmationModal: {
          deleteTitle: "¿Eliminar mensaje programado?",
          deleteMessage: "Esta acción no se puede revertir.",
          deleteMediaTitle: "¿Eliminar archivo adjunto?",
          deleteMediaMessage: "El archivo se quitará de este mensaje programado."
        },
        toasts: {
          deleted: "Programación eliminada con éxito."
        }
      },
      messageModal: {
        title: {
          add: "Nuevo mensaje programado",
          edit: "Editar mensaje programado"
        },
        success: {
          save: "Mensaje guardado con éxito."
        },
        form: {
          connection: "Conexión",
          contacts: "Contactos",
          users: "Usuarios"
        },
        validation: {
          bodyMin: "Mensaje demasiado corto",
          required: "Obligatorio"
        }
      },
      webhookModal: {
        title: {
          add: "Agregar webhook",
          edit: "Editar webhook"
        },
        saveSuccess: "Webhook guardado con éxito.",
        toasts: {
          update: "Webhook actualizado con éxito."
        }
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nueva Columna",
          editKanban: "Editar Columna"
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en horas para redirigir a la columna",
          nextLaneId: "Columna",
          greetingMessageLane: "Mensaje de bienvenida de la columna",
          rollbackLaneId: "Volver a la Columna después de retomar el atendimiento"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Etiqueta guardada con éxito.",
        successKanban: "Columna guardada con éxito."
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos"
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo"
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción"
        },
        success: "¡Lista de archivos guardada con éxito!"
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a conversar."
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO ⬇️",
          titleFileList: "Lista de archivo(s)"
        }
      },
      chatInternal: {
        new: "Nueva",
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar"
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede revertir, ¿confirmar?"
        }
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Colas"
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos"
        },
        toasts: {
          deleted: "El atendimiento que estabas fue eliminado."
        },
        notification: {
          message: "Mensaje de"
        },
        tabs: {
          open: {
            title: "Abiertas"
          },
          closed: {
            title: "Resueltos"
          },
          search: {
            title: "Búsqueda"
          }
        },
        search: {
          placeholder: "Buscar atendimiento y mensajes",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente"
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por contactos",
          filterStatus: "Filtrar por estado",
          filterTags: "Filtrar por etiquetas",
          filterQueues: "Filtrar por departamentos",
          ticketsPerPage: "Tickets por página",
          searchInMessages: "Marque para buscar también en el contenido de los mensajes (más lento)"
        },
        filters: {
          keyWord: "Palabra clave",
          updatedAt: "Fecha de actualización",
          to: "Hasta"
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a la Cola",
          scredule: "Programación",
          quickmessageflash: "Respuesta rápida",
          deleteTicket: "Eliminar Ticket"
        },
        sorting: {
          ascending: "Ascendente",
          descending: "Descendente"
        },
        closedTicket: {
          closedMessage: "Cerrar Ticket Con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sin Mensaje de Despedida"
        }
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Selecciona una cola",
        fieldWhatsapp: "Selecciona un whatsapp",
        noOptions: "Ningún usuario encontrado con ese nombre",
        msgTransfer: "Observaciones - mensaje interno, no va para el cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar"
        }
      },
      ticketsList: {
        called: "Llamado",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage: "Ningún atendimiento encontrado con este estado o término buscado",
        noMessages: "Sin mensajes",
        connectionTitle: "Conexión",
        noQueue: "Sin Cola",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opciones de Kanban"
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar sector"
        }
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar"
        }
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar"
        }
      },
      emails: {
        subMenus: {
          inbox: "Recibidos",
          sent: "Enviados",
          trash: "Eliminados"
        },
        sync: "Sincronizar correos",
        empty: "No hay conversaciones de correo en esta carpeta.",
        comingSoon: "La bandeja de correo estará disponible pronto."
      },
      tasks: {
        title: "Tareas",
        new: "Nueva tarea",
        followUp: "Seguimiento",
        reminder: "Recordatorio de tarea",
        created: "Tarea creada",
        updated: "Tarea actualizada",
        completed: "Tarea completada",
        deleted: "Tarea eliminada",
        contact: "Contacto",
        markDone: "Marcar completada",
        empty: "No tienes tareas",
        emptyHint: "Crea recordatorios personales desde aquí o desde el chat.",
        stats: {
          pending: "Pendientes",
          today: "Hoy",
          overdue: "Vencidas"
        },
        tabs: {
          pending: "Pendientes",
          completed: "Completadas",
          all: "Todas"
        },
        views: {
          list: "Lista",
          calendar: "Calendario"
        },
        calendar: {
          dayDetail: "Tareas del día",
          noTasksDay: "No hay tareas este día.",
          close: "Cerrar",
          more: "más"
        },
        status: {
          completed: "Completada",
          overdue: "Vencida",
          today: "Hoy",
          tomorrow: "Mañana"
        },
        validation: {
          title: "El título es obligatorio",
          date: "La fecha es obligatoria"
        },
        modal: {
          createTitle: "Nueva tarea personal",
          editTitle: "Editar tarea",
          title: "Título",
          body: "Descripción / notas",
          remindAt: "Fecha y hora del recordatorio",
          remindPreview: "Recordatorio",
          save: "Guardar tarea",
          hint: "Recordatorio solo para ti (agente), no se envía al cliente."
        }
      },
      mainDrawer: {
        filter: "Filtrar",
        loading: "Cargando...",
        loadingMessages: "Cargando mensajes...",
        listItems: {
          dashboard: "Dashboard",
          connections: "Conectores",
          chatsTempoReal: "Panel",
          tickets: "Chats",
          tasks: "Tareas",
          emails: "Correos",
          quickMessages: "Respuestas rápidas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          flowbuilder: "Crear Flujo AI",
          tags: "Etiquetas",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Mensajes Programados",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Facturas",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Open AI",
          allConnections: "Administrar conexiones",
          reports: "Informes",
          management: "Gerencia"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y daré continuidad en tu atendimiento.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inválido, por favor entra en contacto con el administrador de la plataforma."
          },
          message: {
            location: "Ubicación",
            contact: "Contacto"
          },
          notRegister: "Ningún registro",
          refresh: "Actualizar",
          loading: "Cargando...",
          filter: "Filtrar",
          loadingMessages: "Cargando mensajes...",
          appName: "NaviChats",
          loadingSystem: "Cargando el sistema..."
        }
      },
      mainHeader: {
        buttons: {
          language: "Idioma"
        }
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugués",
        es: "Español",
        en: "English",
        tr: "Türkçe"
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID del usuario/agente",
          queueId: "ID de la Cola"
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado"
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media"
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1: "Antes de enviar mensajes, es necesario el registro del token vinculado a la conexión que enviará los mensajes. <br />Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el debido campo.",
            comments2: "El número para envío no debe tener máscara o caracteres especiales y debe ser compuesto por:",
            codeCountry: "Código del País",
            code: "DDD",
            number: "Número"
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          },
          media: {
            title: "2. Mensajes de Media",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          }
        },
        toasts: {
          sent: "Mensaje enviado con éxito"
        }
      },
      notifications: {
        noTickets: "Ninguna notificación."
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Exclusión",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea proseguir?"
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar archivo",
          cancel: "Cancelar",
          edit: "Editar"
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo removido con éxito!"
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión"
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado"
        }
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lista"
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          deleted: "Registro excluido"
        }
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar"
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Desea importar los contactos de esta planilla? ",
          importTitlte: "Importar"
        },
        toasts: {
          deleted: "Registro excluido"
        }
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        search: "Buscar",
        addColumns: "+ Agregar columnas",
        subMenus: {
          list: "Panel",
          tags: "Lanes"
        }
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listado",
          listContacts: "Lista de contactos",
          settings: "Configuraciones"
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Disparo",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido"
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos"
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          option: "Ninguna",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Concluída",
          confirmation: "Confirmación",
          actions: "Acciones"
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo visualización",
          help: "Utiliza variables como {nombre}, {numero}, {email} o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contacto",
            tagList: "Etiquetas",
            statusTicket: "Estado del Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Cerrar",
            attach: "Adjuntar archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido"
        },
        phrase: {
          titleAdd: "Nueva campaña con flujo por frase",
          titleEdit: "Editar campaña con flujo por frase",
          nameLabel: "Nombre del disparo por frase",
          phraseLabel: "¿Qué frase dispara el flujo?",
          status: "Estado",
          selectConnection: "Seleccione una conexión",
          create: "Crear campaña",
          save: "Guardar campaña",
          cancel: "Cancelar",
          success: "Frase creada con éxito"
        }
      },
      campaignReport: {
        title: "Informe de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregues",
        connection: "Conexión",
        contactLists: "Lista de Contactos",
        schedule: "Programación",
        conclusion: "Conclusión"
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos"
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones"
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo visualización",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro excluido"
        }
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas"
      },
      queues: {
        title: "Colas & Chatbot",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          orderQueue: "Ordenación de la cola (bot)",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar cola"
        },
        toasts: {
          success: "Cola guardada con éxito",
          deleted: "Cola excluida con éxito"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir. Los tickets de esta cola seguirán existiendo, pero ya no tendrán cola asignada."
        }
      },
      queueOptions: {
        optionTitle: "Título de la opción",
        optionText: "Escribe el texto de la opción",
        confirmDelete: "¿Estás seguro? Todas las opciones internas también serán eliminadas."
      },
      queue: {
        queueData: "Datos"
      },
      queueSelect: {
  inputLabel: "Colas",
  singlePlaceholder: "Selecciona una cola",
  inputLabelRO: "Colas de solo lectura",
  withoutQueue: "Sin cola",
  undefined: "Cola no encontrada",
      },
      reports: {
        title: "Informes de Atendimientos",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha Apertura",
          dateClose: "Fecha Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atendimiento"
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo evaluados"
        },
        searchPlaceholder: "Buscar..."
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones"
        },
        buttons: {
          add: "Agregar Proyecto"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir y se eliminará de las colas y conexiones vinculadas."
        },
        toasts: {
          deleted: "Integración eliminada con éxito."
        }
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar usuario"
        },
        toasts: {
          deleted: "Usuario excluido con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Los atendimientos abiertos de este usuario se moverán para la cola."
        }
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre Plan",
          numberQueues: "Colas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Mensajes programados",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
          lastLogin: "Últ. Login",
          actions: "Acciones",
          money: "€",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar"
        },
        buttons: {
          add: "Agregar empresa"
        },
        toasts: {
          deleted: "Empresa excluida con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos de la empresa se perderán. Los tickets abiertos de este usuario se moverán para la cola."
        }
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Mensajes Programados",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "€",
          public: "Público"
        }
      },
      helps: {
        title: "Central de Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar"
        }
      },
      schedules: {
        title: "Mensajes Programados",
        noPermission: "Esta empresa no tiene permiso para acceder a esta página. Redirigiendo...",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres excluir este mensaje programado?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones"
        },
        buttons: {
          add: "Nuevo Mensaje Programado"
        },
        calendarStatus: {
          agendado: "Programado",
          vencido: "Vencido",
          enviado: "Enviado",
          erro: "Error"
        },
        toasts: {
          deleted: "Mensaje programado excluido con éxito."
        },
        modal: {
          repeatEnabled: "Repetir mensaje",
          repeatDescription: "Por defecto el mensaje se envía una sola vez. Activa esta opción solo si necesitas cobros, recordatorios u otras repeticiones.",
          repeatEvery: "Enviar cada",
          repeatTimes: "Total de envíos (incluye el primero)",
          repeatPresets: {
            "1h": "1 hora",
            "6h": "6 horas",
            "12h": "12 horas",
            "1d": "1 día",
            "2d": "2 días",
            "3d": "3 días",
            "1w": "1 semana",
            "2w": "2 semanas",
            "1m": "1 mes"
          },
          recurrence: "Recurrencia",
          recurrenceDescription: "Configura la repetición del mensaje programado.",
          interval: "Intervalo",
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          intervalValue: "Valor del intervalo",
          sendHowManyTimes: "Cantidad de envíos",
          sendNormallyOnNonWorkingDays: "Enviar normalmente en días no laborables",
          sendOneWorkingDayBefore: "Enviar un día laborable antes",
          sendOneWorkingDayAfter: "Enviar un día laborable después"
        }
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Tag"
        },
        toasts: {
          deleted: "Tag excluido con éxito."
        }
      },
      tagsKanban: {
        title: "Lanes",
        stageLabel: "Etapa Kanban",
        laneDefault: "Contacto inicial",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          name: "Nombre",
          color: "Color",
          order: "Orden",
          tickets: "Tickets",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lane",
          saveOrder: "Guardar orden",
          moveUp: "Subir",
          moveDown: "Bajar",
          dragHint: "Arrastrar para reordenar"
        },
        toasts: {
          deleted: "Lane excluida con éxito.",
          orderSaved: "Orden de etapas guardado."
        }
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción"
        },
        toasts: {
          deleted: "¡Lista excluida con éxito!",
          deletedAll: "¡Todas las listas fueron excluidas con éxito!"
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?"
        }
      },
      settings: {
        success: "Configuraciones guardadas con éxito.",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda"
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado"
            }
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda"
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Company/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Horario de atención",
            queueManagement: "Gestión por cola",
            companyManagement: "Gestión por empresa",
            connectionManagement: "Gestión por conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket: "Enviar mensaje transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo del Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "Informar que no acepta llamadas en whatsapp?",
            sendSignMessage: "Permitir que el agente elija enviar firma",
            sendGreetingMessageOneQueues: "Enviar saludo cuando haya solamente 1 fila",
            sendQueuePosition: "Enviar mensaje con la posición de la cola",
            sendFarewellWaitingTicket: "Enviar mensaje de despedida en espera",
            acceptAudioMessageContact: "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento LGPD",
            requiredTag: "Tag obligatoria para cerrar ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir para otra cola",
            DirectTicketsToWallets: "Mover automáticamente cliente para cartera",
            showNotificationPending: "Mostrar notificación para tickets pendientes"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la cola",
            AcceptCallWhatsappMessage: "Mensaje para informar que no acepta llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = cola destino",
            defaults: {
              transferMessage: "Su atención fue transferida al sector ${queue.name}. Por favor, espere un momento.",
              greetingAcceptedMessage: "¡Hola! Ahora estoy a cargo de tu atención. ¿En qué puedo ayudarte?",
              AcceptCallWhatsappMessage: "Por el momento no aceptamos llamadas por WhatsApp. Por favor, envíanos un mensaje de texto.",
              sendQueuePositionMessage: "Tu posición en la cola es"
            }
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de bienvenida(LGPD)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ocultar mensaje eliminado",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ocultar número de teléfono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado"
          },
          whitelabel: {
            primaryColorLight: "Color Primario Modo Claro",
            primaryColorDark: "Color Primario Modo Oscuro",
            systemName: "Nombre del sistema",
            lightLogo: "Logotipo claro",
            darkLogo: "Logotipo oscuro",
            favicon: "Favicon"
          }
        }
      },
      messagesList: {
        contact: "Contacto",
        deletedMessage: "Mensaje eliminado",
        deletedByContact: "Este mensaje fue eliminado por el contacto",
        deletedBySystem: "Este mensaje fue eliminado",
        metaReplyWindow:
          "Tienes 24 horas para responder después de recibir un mensaje, según las políticas de Facebook.",
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle: "¿Desea dejar una evaluación de atendimiento para el cliente?",
          dialogClosingTitle: "¡Finalizando el atendimiento con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un menú de evaluación",
          notMessage: "Ningún mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar integración",
            disableIntegration: "Deshabilitar integración",
            logTicket: "Logs del Ticket",
            requiredTag: "Debes asignar una etiqueta antes de cerrar el ticket."
          }
        }
      },
      messagesInput: {
        placeholderPrivateMessage: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderOpen: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Assinar",
        privateMessage: "Mensaje Privado"
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear"
        },
        extraInfo: "Otras informaciones"
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº de Llamada",
          queue: "Sector",
          connection: "Conexión"
        }
      },
      ticketOptionsMenu: {
        schedule: "Programar mensaje",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Finalizar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Ticket",
          textarea: "Observación",
          placeholder: "Inserta aquí la información que deseas registrar"
        },
        confirmationModal: {
          title: "Eliminar el ticket del contacto",
          titleFrom: "del contacto ",
          message: "¡Atención! Todas las mensajes relacionadas con el ticket se perderán."
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar"
        }
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Deshabilitar Firma",
          privateMessage: "Habilitar/Deshabilitar Mensaje Privada",
          meet: "Enviar link para videoconferencia",
          agentTask: "Crear tarea personal (recordatorio)"
        },
        type: {
          imageVideo: "Fotos y vídeos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Vídeo llamada"
        }
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Conversar Con",
        react: "Reaccionar",
        reactionSuccess: "Reacción enviada con éxito",
        confirmationModal: {
          title: "¿Apagar mensaje?",
          message: "Esta acción no se puede revertir."
        },
        editMessageModal: {
          title: "Editar mensaje"
        }
      },
      invoices: {
        title: "Facturas",
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Vencimiento",
          status: "Estado",
          action: "Acción",
          tooltips: {
            details: "Detalles de la factura",
            users: "Número de usuarios",
            connections: "Número de conexiones",
            queues: "Número de colas",
            value: "Valor de la factura",
            dueDate: "Fecha de vencimiento"
          }
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "Pendiente"
        },
        dueDate: {
          overdueDays: "Vencido hace {{days}} días",
          today: "Vence hoy",
          inDays: "Vence en {{days}} días"
        },
        counts: {
          users: "{{count}} usuarios",
          connections: "{{count}} conexiones",
          queues: "{{count}} colas"
        },
        buttons: {
          payNow: "PAGAR AHORA",
          pay: "PAGAR",
          paid: "PAGADO"
        }
      },
      moments: {
        title: "Panel de Atendimientos",
        attendances: "Atendimientos",
        pending: "Pendientes",
        accessTicket: "Acceder Ticket"
      },
      calendar: {
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el día",
        week: "Semana",
        work_week: "Programación",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay agendamientos en el período.",
        showMore: "más"
      },
      frontEndErrors: {
        getUsers: "Error al cargar usuarios."
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "Ningún WhatsApp predeterminado encontrado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, intente nuevamente.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un tíquete abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuario fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "Ninguna configuración encontrada con este ID.",
        ERR_NO_CONTACT_FOUND: "Ningún contacto encontrado con este ID.",
        ERR_NO_TICKET_FOUND: "Ningún tíquete encontrado con este ID.",
        ERR_NO_USER_FOUND: "Ningún usuario encontrado con este ID.",
        ERR_NO_WAPP_FOUND: "Ningún WhatsApp encontrado con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear tíquete en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta color ya está en uso, elija otra.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de bienvenida es obligatorio cuando hay más de una cola.",
        ERR_OUT_OF_HOURS: "¡Fuera del Horario de Expediente!",
        ERR_ASSISTANT_NO_PROMPT: "No hay ninguna integración de IA configurada. Crea un prompt en Open AI con tu API key.",
        ERR_ASSISTANT_NO_API_KEY: "La integración seleccionada no tiene API key configurada.",
        ERR_ASSISTANT_UNSUPPORTED_MODEL: "El modelo configurado no es compatible con el asistente.",
        ERR_ASSISTANT_EMPTY_MESSAGE: "Escribe un mensaje para el asistente.",
        ERR_ASSISTANT_AI_FAILED: "No se pudo obtener respuesta de la IA. Revisa la API key y el modelo en Conectores → Open AI.",
        ERR_ASSISTANT_TIMEOUT: "La IA tardó demasiado en responder. Intenta de nuevo.",
        ERR_WEB_SEARCH_NO_API_KEY: "La búsqueda web está activa pero no hay API key de Tavily. Configúrala en el conector Tavily o en TAVILY_API_KEY del servidor.",
        ERR_WEB_SEARCH_FAILED: "No se pudo consultar internet en este momento. Intenta de nuevo más tarde.",
        ERR_TAVILY_PROMPT_ALREADY_ASSIGNED: "Una o más configuraciones Open AI ya están asignadas a otro conector Tavily.",
        ERR_CHAT_AGENT_NOT_CONFIGURED: "No hay configuraciones Open AI disponibles. Crea una en Conectores.",
        ERR_CHAT_AGENT_PROMPT_NOT_ALLOWED: "El agente seleccionado no está disponible.",
        ERR_CHAT_AGENT_PROMPT_NOT_FOUND: "No se encontró el agente IA seleccionado.",
        ERR_CHAT_AGENT_PROMPT_ALREADY_ASSIGNED: "Una o más configuraciones Open AI ya están asignadas a otro conector de Agente IA.",
        ERR_CHAT_AGENT_EMPTY_RESPONSE: "La IA no devolvió un análisis. Intenta de nuevo.",
        ERR_CHAT_AGENT_INVALID_RESPONSE: "La IA devolvió un formato inválido. Revisa las instrucciones del prompt.",
        ERR_CHAT_AGENT_REFINE_EMPTY: "Escribe una indicación para refinar la sugerencia.",
        ERR_CHAT_AGENT_ANALYSIS_NOT_FOUND: "No se encontró el análisis a refinar."
      },
      assistant: {
        title: "Asistente IA",
        open: "Abrir asistente",
        settings: "Configuración",
        welcome: "Pregúntame lo que necesites: correos, mensajes, ideas… Te respondo listo para copiar y pegar.",
        placeholder: "Ej: Redacta un correo para un cliente que pidió cotización…",
        model: "Integración Open AI",
        activeIntegration: "Activa: {{name}}",
        copy: "Copiar respuesta",
        copied: "Copiado al portapapeles",
        thinking: "Pensando…",
        noPrompt: "Aún no hay integración IA. Crea un prompt con tu API de ChatGPT o Gemini.",
        goSetup: "Ir a Conectores → Open AI"
      }
    }
  }
};

export { messages };
